import React, { useContext, useState } from 'react';
import { useMutation } from '@apollo/client';
import { useForm } from 'react-hook-form';

import { Button } from 'app/src/elements/buttons';
import { Fields, defaultValues } from 'app/src/elements/forms';
import Modal from 'app/src/elements/Modal';
import { Text } from 'app/src/styles';

import { UPDATE_ORDER_SHOPIFY_ORDER_NUMBER } from './queries';

const FIELDS = {
  shopifyOrderNumber: {
    label: 'Shopify Order Number',
  },
};

const EditShopifyOrderNumber = ({ order, setShow, refetch }) => {
  const [formStatus, setFormStatus] = useState();

  const { control, handleSubmit, formState: { errors } } = useForm({
    defaultValues: defaultValues({ fields: FIELDS, resource: order })
  });

  const [updateOrderShopifyOrderNumber] = useMutation(
    UPDATE_ORDER_SHOPIFY_ORDER_NUMBER, {
      onCompleted: () => { setShow(false); refetch(); }
    },
  );

  const onSubmit = input => {
    setFormStatus('submitting');
    updateOrderShopifyOrderNumber({ variables: { id: order.id, ...input } });
  };

  return (
    <Modal title="Set Shopify Order Number" setShow={setShow}>
      <Text style={{ marginBottom: 10 }}>{order.dealer.label}</Text>

      <Fields fields={FIELDS} control={control} errors={errors} />

      {'submitting' === formStatus ? (
        <Text>Processing...</Text>
      ) : (
        <Button label="Save" onPress={handleSubmit(onSubmit)} wide />
      )}
    </Modal>
  );
};

export default EditShopifyOrderNumber;
